<template>
    <div class="assess">
        <!-- 顶部导航 -->
        <div class="nav">
            <div class="nav_left">
                <van-icon name="arrow-left" color="#fff" size="1.2rem" @click="back" />
                <span>评价详情</span>
            </div>
            <div @click="submit">发布</div>
        </div>
        <!-- 填写内容 -->
        <van-panel class="sale">
            <div class="content">
                <div class="list">
                    <van-cell>
                        <div slot="title" class="title">
                            <span>整体评价</span>
                            <van-rate v-model="hot_num" gutter="0.5rem" :size="16" color="#F1452F" void-icon="star"
                                void-color="#eee" />
                        </div>
                    </van-cell>
                    <van-cell-group>
                        <van-field v-model="content" maxlength="200" rows="5" autosize type="textarea"
                            placeholder="宝贝满足你的期待吗？说说你的使用心得,分享给想要购买的朋友们吧" show-word-limit />
                        <van-uploader v-model="fileList" multiple :max-count="4" />
                    </van-cell-group>
                    <van-cell>
                        <div slot="title">
                            <div class="status status_acticve_hide" v-if="anonymous == 0" @click="anonymous = 1">
                                <img src="../../assets/hide.png" alt="">
                                <span>匿名</span>
                            </div>
                            <div class="status status_acticve_open" v-else @click="anonymous = 0">
                                <img src="../../assets/open.png" alt="">
                                <span>公开</span>
                            </div>
                        </div>
                    </van-cell>
                </div>
            </div>
        </van-panel>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                message: '',
                fileList: [],
                anonymous: 0,
                hot_num: 5,
                content: ''
            }
        },
        methods: {
            //提交评论
            submit() {
                const toast = this.$toast.loading({
                    duration: 0,
                    forbidClick: true,
                    message: '提交中',
                    loadingType: 'spinner'
                });
                let img_list = [];
                for (let p in this.fileList) {
                    let content = this.fileList[p].file;
                    let data = new FormData();
                    data.append('file', content);
                    this.$axios.post(baseUrl + '/mobile/Index/imgUpload', data, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }).then((res) => {
                        if (res.data.code == 11) {
                            img_list.push(res.data.data);
                        } else {
                            this.$toast('上传失败');
                            this.$toast.clear();
                        }
                    }).catch((err) => {
                        console.log(err);
                    })
                }
                setTimeout(() => {
                    this.$axios.post(baseUrl + '/mobile/Order/goodsOneComment', {
                        goods_id: this.$route.query.id,
                        anonymous: this.anonymous,
                        hot_num: this.hot_num,
                        content: this.content,
                        image: img_list,
                        token: localStorage.getItem('Authorization')
                    }).then((res) => {
                        if (res.data.code == 23) {
                            this.$toast(res.data.msg);
                            this.$toast.clear();
                            this.back();
                        }
                    }).catch((err) => {
                        console.log(err);
                    })
                }, 500)
            }
        }
    }
</script>

<style>
    @import '../min/assess.css'
</style>


// WEBPACK FOOTER //
// src/components/home/limitChain.vue